import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

interface TabHeaderProps {
  title: ReactNode;
  subtitle: ReactNode;
  className?: string;
}

export const TabHeader: FC<TabHeaderProps> = ({
  title,
  subtitle,
  className,
}) => {
  return (
    <div className={cx("flex flex-col gap-1", className)}>
      <span className="font-secondary text-lg font-medium text-black">
        {title}
      </span>
      <span className="text-dark-700 font-secondary text-sm leading-[140%] tracking-[0.14px]">
        {subtitle}
      </span>
    </div>
  );
};
